import request from "@/service/request";

export function getCommodity() {
    return request.get(
        "/commodity/getCommodity",
    );
}

export function sendCode(params) {
    return request.post(
        "/patient/sendVerifiableCode",
        params,
        {
            headers: {
                "X-AUTH-END": "PC"
            },
        }
    );
}

export function login(params) {
    return request.post(
        "/patient/loginByCode",
        params,
        {
            headers: {
                "X-AUTH-END": "PC"
            },
        }
    );
}

export function getUserInfo(token) {
    return request.get(
        "/patient/getUserInfo",
        {
            headers: {
                "X-Auth-Token": token,
            },
        }
    );
}

export function addOrder(params, token) {
    return request.post(
        "/commodity/addOrder",
        params,
        {
            headers: {
                "X-Auth-Token": token,
            },
        }
    );
}

export function getPayResult(orderId, token) {
    return request.get(
        "/commodity/getPayResult?orderId=" + orderId,
        {
            headers: {
                "X-Auth-Token": token,
            },
        }
    );
}

